import React, { useEffect } from 'react';
import GenericButton from './GenericButton';
import Image from './Image';
import { useSelector, useDispatch } from 'react-redux';
import { setInsurancePopupOpen, setAnimationInsurance } from '../app/mainSlice';

/**
 * @param props.delay
 * @param props.handleApply
 * @param props.handleSkip
 * @param props.isOpen
 */
const InsurancePopup = props => {
    const dispatch = useDispatch();
    const labels = useSelector(state => state.main.labels);
    const isInsuranceLogged = useSelector(state => state.main.isInsuranceLogged);
    const isInsurancePopupOpen = useSelector(state => state.main.isInsurancePopupOpen);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);
    const currentStep = useSelector(state => state.main.currentStep);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const animationInsurance = useSelector(state => state.main.animationInsurance);

    let insurancePopupTimer = null;

    useEffect(() => {
        if (isInsurancePopupOpen) {
            insurancePopupTimer = setTimeout(() => {
                dispatch(setInsurancePopupOpen(false));
                setTimeout(() => {
                    dispatch(setAnimationInsurance(false));
                }, 500);
            }, props.delay * 1000);
        }
    }, []);

    return !isLearnMoreModalOpen ? (
        <div
            className={
                'insurance-modal-container' +
                (!isInsurancePopupOpen || isInsuranceLogged ? ' collapsed' : '')
            }
            id="insurance-modal-out"
        >
            <div className="overlay"></div>
            <div
                className={
                    'insurance-modal ' +
                    (animationInsurance ? ' insurance-modal-animation' : ' insurance-modal-chat')
                }
                id="insurance-modal"
            >
                {!isInsurancePopupOpen ? (
                    <a
                        data-element-id={
                            'X_X_LensPanel_' +
                            labels.stepAnalyticsName[currentStep] +
                            '-UseInsurance'
                        }
                        href="#"
                        onClick={props.handleApply}
                    >
                        <div id="countdown">
                            <Image
                                imageClass="countdown-shield"
                                url={baseURLs.projectImage}
                                fileName="insurance-shield"
                                alt="countdown insurance image"
                            />
                        </div>
                    </a>
                ) : (
                    <div id="countdown">
                        <Image
                            imageClass="countdown-shield"
                            url={baseURLs.projectImage}
                            fileName="insurance-shield"
                            alt="countdown insurance image"
                        />
                        <svg>
                            <circle r="18" cx="21" cy="21"></circle>
                        </svg>
                    </div>
                )}
                <div className="insurance-title">{labels.insuranceTitle}</div>
                <div className="insurance-sub-title">{labels.insuranceSubTitle}</div>
                <div className="button-container">
                    <div className="insurance-button-apply">
                        <GenericButton className="button apply" handleClick={props.handleApply}>
                            {labels.applyInsurance}
                        </GenericButton>
                    </div>
                    <div className="insurance-button-skip">
                        <GenericButton
                            className="button skip"
                            handleClick={() => {
                                if (insurancePopupTimer) {
                                    clearTimeout(insurancePopupTimer);
                                }

                                props.handleSkip();
                            }}
                        >
                            {labels.skipForNow}
                        </GenericButton>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

export default InsurancePopup;
